import React, { useContext } from 'react';
import dictData from 'dictionary';
import { MatchMediaContext } from 'context/MatchMediaContext';
import { ReactComponent as MyOseLogoWhite } from 'images/icons/moje-ose-white.svg';
import { ReactComponent as MyOseLogo } from 'images/icons/moje-ose.svg';
import routeList from 'routes/routeList';
import HomeSectionHeader from './HomeSectionHeader';

const HomeMojeOse: React.FC = () => {
  const { isMd, isLg } = useContext(MatchMediaContext);
  const whiteLogo = isMd || isLg;
  return (
    <section className="home-myose-wrapper">
      <div className="home-myose-overlay" />
      <div className="home-myose-container content-wrapper">
        {whiteLogo ? <MyOseLogoWhite className="home-myose-logo" /> : <MyOseLogo className="home-myose-logo" />}
        <div className="home-myose-logo" />
        <HomeSectionHeader
          title={dictData.home.myOse.title}
          description={dictData.home.myOse.description}
          ctaHref={routeList.mojeOse}
          ctaButtonText={dictData.home.myOse.ctaButtonText}
        />
      </div>
    </section>
  );
};

export default HomeMojeOse;
